import React from 'react'
import { Box, Button, Anchor, Text } from "grommet"
import { Analytics } from "grommet-icons"

export const TTHAProxyLink = ({ url }) => {
    return (
        <Box
            justify="center"
            align="center"
            gap="none"
            background="dark-2"
            width="120px"
            alignSelf="center"
            alignContent="center"
            round="xsmall"
        >
            <Anchor target="_blank" alignSelf="center" margin={{ left: "6px", right: "6px" }} href={url}>
                <Button plain label={<Text color="white" size="12px" weight="normal">HAProxy</Text>} margin={{top: "xxsmall"}} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<Analytics size="16px" color="white" />} />
            </Anchor>
        </Box>
    )
    }

export default TTHAProxyLink
